<template>
  <div class="shopsetting">
    <LeoHandB title="我的小店" curactive="setting">
      <div slot="content">
        <div class="heightfull">
          <div class="main-options-no">
            <div class="form-structor">
              <div class="signup">
                <div class="code-img">
                  <div class="code-main left" v-if="qrcode != ''">
                    <img :src="qrcode" alt="">
                    <van-button @click="gotorouter" round plain size="small" type="info">H5</van-button>
                  </div>
                  <div class="code-main right" v-if="app_qrcode != ''">
                    <img :src="app_qrcode" alt="">
                    <div class="wx-jump">
                      <van-button round size="small" type="info">小程序</van-button>
                      <wx-open-launch-weapp
                          :username="username"
                          :path="path"
                          ref="launchWeapp"
                          launch="onLaunchWeapp"
                          style="width: 100%;height: 100%;position: absolute;
							top: 0;left: 0;">
                        <script type="text/wxtag-template">
                          <style>
                            .btn{
                              position: absolute;
                              top: 0;
                              left: 0;
                              width: 100%;
                              height: 100%;
                              opacity: 0;
                            }
                            </style>
                          <button class="btn">打开小程序</button>
                      </script>
                      </wx-open-launch-weapp>
                    </div>
                  </div>
                </div>
              </div>
              <div class="login slide-up">
                <div class="centerlogin">
                  <div class="form-title" id="login">智慧旅业</div>
                </div>
              </div>
              <div class="bgimage" style="background-image:url(https://www.jonlv.com/assets/img/login-bg.gif)"></div>
            </div>
          </div>
        </div>
      </div>
    </LeoHandB>
  </div>

</template>

<script>
  import LeoHandB from '../TP/LeoHandB.vue'
  import * as util from '@/utils/network'
  export default {
    components: {
      LeoHandB
    },
    data() {
      return {
        username: '',
        qrcode: '',
        url: '',
        app_qrcode: '',
        path: '',
      }
    },
    mounted() {
      //this.getConfig(),
      this.getQrcode();
      this.$refs.launchWeapp.launch();
    },
    methods: {
      onLaunchWeapp(event) {
        // 唤起成功或失败时的处理
        if (event.detail.errMsg === "launchWeapp:ok") {
          console.log("唤起成功");
        } else {
          console.error("唤起失败", event.detail.errMsg);
        }
      },
      getQrcode() {
        let that = this
        var url = "/addons/litestore/api.store/store"

        let param = {
          store_id: that.$store.getters.getShop
        }
        util.post(url, param, function (result) {
          console.log(result)
          that.username = result.data.username
          that.qrcode = result.data.wechat.qrcode
          that.url = result.data.wechat.url

          that.app_qrcode = result.data.app.qrcode
          that.path = result.data.app.path

        });
      },
      /*getConfig() {
        let that = this
        var href = window.location.href
        if (window.__wxjs_is_wkwebview) {
          if (window.entryUrl == '' || window.entryUrl == undefined) {
            window.entryUrl = window.location.href.split('#')[0]
          }
          href = window.entryUrl
        }
        var url = "/addons/litestore/api.index/getJsSdkConfig"

        let param = {
          url: href,
          store_id: that.$store.getters.getShop
        }
        util.post(url, param, function (result) {
          console.log(result)
          //初始配置
          var config = result.data.config;
          that.username = config.username

          wx.config({
            debug: config.debug, // 调试时可开启
            appId: config.appId, // <!-- replace -->
            timestamp: data.timestamp, // 生成签名的时间戳，必填，填任意数字即可
            nonceStr: data.nonceStr, // 生成签名的加密字符串，必填，填任意非空字符串即可
            signature: data.signature, // 生成的签名，必填，填任意非空字符串即可
            jsApiList: ["chooseImage", "previewImage",
              "wx-open-launch-weapp"
            ], // 必填，随意一个接口即可（跳转小程序的任意接口即可）
            openTagList: ["wx-open-launch-weapp"], // 填入打开小程序的开放标签名
          });
          /!* eslint-disable *!/
          wx.ready(function () {
            console.log('ready')
          });
        });
      },*/
      gotorouter() {
        let that = this
        window.location.href = that.url
      }
    },
  }
</script>

<style lang="less" scoped>
  .heightfull {
    position: fixed;
    width: 100%;
    height: calc(100% - 100px);
  }

  .main-options-no {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #E1E8EE;
  }

  .form-structor {
    background-color: #E1E8EE;
    border-radius: 15px;
    height: 80vh;
    width: 90%;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    z-index: 1;
  }

  .form-structor .bgimage {
    content: "";
    opacity: 1;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
  }

  .form-structor .signup {
    position: relative;
    z-index: 5;
    align-self: center;
    margin-top: 75px;
  }

  .form-structor .signup .form-title {
    color: #fff;
    font-size: 25px;
    font-family: "Fira Sans", Helvetica, Arial, sans-serif;
    text-align: center;
  }

  .form-structor .signup .submit-btn {
    background-color: rgba(109, 24, 158, 0.8);
    color: rgba(255, 255, 255, 0.7);
    border: 0;
    border-radius: 15px;
    display: block;
    margin: 15px auto;
    padding: 0 70px;
    height: 45px;
    line-height: 45px;
    width: 100%;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    opacity: 1;
    visibility: visible;
  }

  .form-structor .login {
    position: relative;
    z-index: 5;
    width: 100%;
    height: 75px;
    line-height: 75px;
    align-self: flex-end;
  }

  .form-structor .login::before {
    content: "";
    position: absolute;
    left: -50%;
    top: 0px;
    background-color: rgba(255, 255, 255, 0.95);
    width: 200%;
    height: 250px;
    border-radius: 50%;
    z-index: 4;
  }

  .form-structor .login .centerlogin {
    position: relative;
    text-align: center;
    z-index: 5;
  }

  .form-structor .login .centerlogin .form-title {
    color: #000;
    font-size: 18px;
    text-align: center;
  }

  .code-img {
    display: flex;
    align-content: center;
    margin-top: 30px;
  }

  .code-main {
    width: 50%;
    text-align: center;
  }

  .code-main img {
    width: 100px;
    height: 100px;
  }

  .code-main button {
    margin-top: 10px;
    width: 110px;
    border: 1px solid rgba(109, 24, 158, 1);
  }

  .right .van-button--info {
    background-color: rgba(109, 24, 158, 0.8);
    color: #Fff;
  }

  .left .van-button--info {
    color: rgba(109, 24, 158, 1);
  }
  .wx-jump {
    overflow: hidden;
    position: relative;
  }
</style>
